import React, { ComponentProps } from 'react';
import { Css } from '@/ui';
import styled from '@emotion/styled';
import { JobType } from '../../../../contentful/types/IJob';
import { Color } from '../../../../styles/Color';

interface IJobTypeOptionsProps {
	value?: JobType[];
	onChange: (value?: JobType[]) => void;
}

function CheckboxButton({
	checked,
	children,
	id,
	...props
}: Omit<ComponentProps<'input'>, 'type' | 'id'> & { id: string }) {
	return (
		<Pill aria-checked={checked}>
			<input type="checkbox" id={id} checked={checked} {...props} />
			<label htmlFor={id}>{children}</label>
		</Pill>
	);
}

export const JobTypeFilters = ({ value, onChange }: IJobTypeOptionsProps) => {
	const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const type = event.target.value as JobType;
		let newValue = value || [];
		const index = newValue.indexOf(type);

		if (index >= 0) {
			newValue.splice(index, 1);
		} else {
			newValue = [...newValue, type];
		}
		onChange(newValue);
	};

	return (
		<Container>
			{Object.values(JobType).map((type) => (
				<CheckboxButton
					key={type}
					name="type"
					value={type}
					checked={value?.includes(type)}
					onChange={handleOnChange}
					id={type}
				>
					{type}
				</CheckboxButton>
			))}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: ${Css.pxToRem(12)};
`;

const Pill = styled.label`
	label {
		display: inline-flex;
		padding: ${Css.pxToRem(6)} ${Css.pxToRem(16)};
		border-radius: 9999px;
		border: 2px solid ${Color.PrimaryBlue};
		font-weight: 500;
		font-size: ${Css.pxToRem(14)};
		color: ${Color.PrimaryBlue};
		cursor: pointer;
	}

	&[aria-checked='true'] label {
		background: ${Color.PrimaryBlue};
		color: ${Color.PrimaryWhite};
	}

	&:focus-within label {
		outline: none;
		box-shadow: 0 0 0 1px ${Color.PrimaryWhite}, 0 0 0 3px ${Color.PrimaryBlue};
	}

	input {
		width: 0;
	}
`;
